import {Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {AuthService} from '../../core/security/auth.service';
import {ReportsService} from '../reports.service';
import * as _ from 'lodash';
import {MatDialog} from '@angular/material/dialog';
import {UsersSummaryV2GridComponent} from './users-summary-v2-grid/users-summary-v2-grid.component';
import {MatUsersSummaryFilterDialogComponent} from '../shared/mat-users-summary-filter-dialog/mat-users-summary-filter-dialog.component';
import {BaseComponent} from '../../core/base.component';
import {SelectedFilterValuesModel} from '../../dialogs/grid-filter/selected-filter-values.model';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import {DateRangeService} from '../../core/services/date-range.service';
import {UsersDashboardService} from '../users-summary/users-dashboard.service';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardContent } from '@angular/material/card';
import { ChartByUserV2Component } from './charts/chart-by-user-v2.component';

@Component({
    selector: 'app-users-summary-v2',
    templateUrl: './users-summary-v2.component.html',
    styleUrls: ['./users-summary-v2.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressBar,
        GridFilterComponent,
        FilterRowAdditionalContentComponent,
        MatButton,
        MatIcon,
        MatCard,
        MatCardContent,
        ChartByUserV2Component,
        UsersSummaryV2GridComponent,
        AsyncPipe,
    ],
})
export class UsersSummaryV2Component extends BaseComponent implements OnDestroy, OnInit {

  filterChangeEvent = new EventEmitter<any>();
  selectedFilterChange = new EventEmitter<SelectedFilterValuesModel[]>();

  selectedFilter: SelectedFilterValuesModel[] = new Array<SelectedFilterValuesModel>();
  filterOptions: FilterOptionModel[] = [];

  additionalFilter: any = {};
  exportColumns: any[] = [];

  userSeriesTotals: any = [];
  userSeriesAvgTotals: any = [];

  @ViewChild('usersSummaryGrid', {static: true}) usersSummaryGrid: UsersSummaryV2GridComponent;

  constructor(public reportsService: ReportsService,
              public usersDashboardService: UsersDashboardService,
              public dateRangeService: DateRangeService,
              public dialog: MatDialog,
              route: ActivatedRoute, public headerService: HeaderService, titleService: Title, authService: AuthService) {
    super(route, headerService, titleService, authService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.headerService.hideSearchInput();

    if (this.reportsService.accountsLookup?.length > 0) {
      this.initFilterOptions();
    } else {
      this.reportsService.lookupUpdatedEvent.subscribe(() => {
        this.initFilterOptions();
      });
    }

    this.usersSummaryGrid.dataSource.dataSubject.subscribe(data => {
      this.userSeriesTotals = data.map(x => {
        return {
          extension: x._id,
          answeredByMailbox: Number(x.totalIncomingMailbox || 0) + Number(x.totalInternalMailbox || 0),
          answeredCalls: Number(x.totalIncomingAnswered || 0) + Number(x.totalInternalAnswered || 0),
          canceled: Number(x.totalIncomingMissed || 0) + Number(x.totalInternalMissed || 0),
          outgoingCalls: Number(x.totalOutgoingCount || 0),
        };
      });

      this.userSeriesAvgTotals = data.map(x => {
        return {
          extension: x._id,
          avgTalkDuration: Number(x.avgTalkDuration),
          totalTalkDuration: Number(x.totalTalkDuration),
          avgRingDuration: Number(x.avgRingDuration),
        };
      });
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  async openExportDialog() {
    await this.usersSummaryGrid.onExportClick();
  }

  onSelectedItemsChanged($event: SelectedFilterValuesModel[]) {
    this.selectedFilter = $event;
  }

  onFilterChanged(filter: any) {
    let extensions = [];

    if (filter['extensions']) {
      extensions = _.union(extensions, filter['extensions']);
      filter['extensions'] = undefined;
    }
    if (filter['departments']) {
      const departments = this.reportsService.getDepartmentsExtensions(filter['departments']);
      extensions = _.union(extensions, departments);
      filter['departments'] = undefined;
    }

    filter['extensions'] = extensions;

    console.log('onFilterChanged', filter);

    this.additionalFilter = filter;
    this.filterChangeEvent.emit(filter);
  }

  openFilterDialog() {
    console.log('open filter dialog');
    const dialogRef = this.dialog.open(MatUsersSummaryFilterDialogComponent, {
      width: '500px',
      height: '90%',
      data: {
        filter: this.selectedFilter
      }
    });

    dialogRef.afterClosed().subscribe(async (result: SelectedFilterValuesModel[]) => {
      if (result) {
        this.selectedFilterChange.emit(result);
      }
    });
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
    ];

    if (this.reportsService.extensionsLookup.length > 0) {
      for (const item of this.reportsService.extensionsLookup) {
        this.filterOptions.push({
          filterKey: 'extensions',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'User',
          displayValue: item.text,
          value: item.value,
          searchText: `User: ${item.text}`,
        });
      }
    }

    if (this.reportsService.departmentsLookup.length > 0) {
      for (const item of this.reportsService.departmentsLookup) {
        this.filterOptions.push({
          filterKey: 'departments',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Department',
          displayValue: item.text,
          value: item.value,
          searchText: `Department: ${item.text}`,
        });
      }
    }
  }
}
